import { render } from "./BasketItems.vue?vue&type=template&id=0dbc7c84&scoped=true&ts=true"
import script from "./BasketItems.vue?vue&type=script&lang=ts"
export * from "./BasketItems.vue?vue&type=script&lang=ts"

import "./BasketItems.vue?vue&type=style&index=0&id=0dbc7c84&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dbc7c84"]])

export default __exports__